(function(){
  function activateGalleryMedia(root, mediaId){
    if(!root || !mediaId) return;
    var gallery=root.querySelector('[data-sp-gallery]');
    if(!gallery) return;
    var target=gallery.querySelector('[data-sp-gallery-item][data-media-id="'+mediaId+'"]');
    if(!target) return;

    gallery.querySelectorAll('[data-sp-gallery-item]').forEach(function(item){
      var active=item===target;
      if(!active){
        item.querySelectorAll('video').forEach(function(video){try{video.pause();}catch(e){}});
      }
      item.hidden=!active;
      item.classList.toggle('is-active',active);
    });

    gallery.querySelectorAll('[data-sp-gallery-thumb]').forEach(function(thumb){
      var active=thumb.getAttribute('data-media-id')===String(mediaId);
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-current',active?'true':'false');
      if(active){
        try{thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});}catch(e){}
      }
    });
  }

  function bindGallery(root){
    root.querySelectorAll('[data-sp-gallery-thumb]').forEach(function(thumb){
      if(thumb.dataset.spBound==='true') return;
      thumb.dataset.spBound='true';
      thumb.addEventListener('click',function(){
        activateGalleryMedia(root,thumb.getAttribute('data-media-id'));
      });
    });
  }

  function bindFooterTabs(scope){
    scope.querySelectorAll('[data-sp-footer-tab]').forEach(function(btn,index){
      if(btn.dataset.spBound!=='true'){
        btn.dataset.spBound='true';
        btn.addEventListener('click',function(){
          if(!window.matchMedia('(max-width: 680px)').matches) return;
          var column=btn.closest('.sp-footer-column');
          if(!column) return;
          var footer=btn.closest('.sp-footer');
          var shouldOpen=!column.classList.contains('is-open');
          if(footer){
            footer.querySelectorAll('.sp-footer-column').forEach(function(other){
              other.classList.remove('is-open');
              var otherBtn=other.querySelector('[data-sp-footer-tab]');
              if(otherBtn) otherBtn.setAttribute('aria-expanded','false');
            });
          }
          if(shouldOpen){
            column.classList.add('is-open');
            btn.setAttribute('aria-expanded','true');
          }
        });
      }
    });

    if(window.matchMedia('(max-width: 680px)').matches){
      scope.querySelectorAll('.sp-footer').forEach(function(footer){
        if(footer.dataset.spTabsInitialized==='true') return;
        footer.dataset.spTabsInitialized='true';
        var first=footer.querySelector('.sp-footer-column');
        if(first){
          first.classList.add('is-open');
          var firstBtn=first.querySelector('[data-sp-footer-tab]');
          if(firstBtn) firstBtn.setAttribute('aria-expanded','true');
        }
      });
    }
  }

  function ready(scope){
    scope=scope||document;

    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            e.target.classList.add('sp-visible');
            io.unobserve(e.target);
          }
        });
      },{threshold:.12});
      scope.querySelectorAll('.sp-reveal:not(.sp-visible)').forEach(function(el){io.observe(el);});
    }else{
      scope.querySelectorAll('.sp-reveal').forEach(function(el){el.classList.add('sp-visible');});
    }

    scope.querySelectorAll('[data-sp-menu-open]').forEach(function(btn){
      if(btn.dataset.spBound==='true') return;
      btn.dataset.spBound='true';
      btn.addEventListener('click',function(){
        var drawer=document.querySelector('[data-sp-mobile-drawer]');
        if(drawer){drawer.setAttribute('aria-hidden','false');document.body.classList.add('sp-menu-open');}
      });
    });

    scope.querySelectorAll('[data-sp-menu-close]').forEach(function(btn){
      if(btn.dataset.spBound==='true') return;
      btn.dataset.spBound='true';
      btn.addEventListener('click',function(){
        var drawer=document.querySelector('[data-sp-mobile-drawer]');
        if(drawer){drawer.setAttribute('aria-hidden','true');document.body.classList.remove('sp-menu-open');}
      });
    });

    scope.querySelectorAll('[data-sp-mobile-drawer] a').forEach(function(a){
      if(a.dataset.spBound==='true') return;
      a.dataset.spBound='true';
      a.addEventListener('click',function(){
        var drawer=document.querySelector('[data-sp-mobile-drawer]');
        if(drawer){drawer.setAttribute('aria-hidden','true');document.body.classList.remove('sp-menu-open');}
      });
    });

    scope.querySelectorAll('[data-sp-faq-button]').forEach(function(btn){
      if(btn.dataset.spBound==='true') return;
      btn.dataset.spBound='true';
      btn.addEventListener('click',function(){
        var item=btn.closest('.sp-faq-item');
        if(!item) return;
        var open=item.classList.toggle('sp-open');
        btn.setAttribute('aria-expanded',open?'true':'false');
      });
    });

    scope.querySelectorAll('[data-sp-product-root]').forEach(function(root){
      bindGallery(root);
      root.querySelectorAll('[data-sp-variant-select]').forEach(function(select){
        if(select.dataset.spBound==='true') return;
        select.dataset.spBound='true';
        var price=root.querySelector('[data-sp-price]');
        var compare=root.querySelector('[data-sp-compare]');
        var atc=root.querySelector('[data-sp-atc]');
        function update(){
          var opt=select.options[select.selectedIndex];
          if(!opt) return;
          if(price && opt.dataset.price) price.textContent=opt.dataset.price;
          if(compare){compare.textContent=opt.dataset.compare||'';compare.style.display=opt.dataset.compare?'inline':'none';}
          if(atc){
            var available=opt.dataset.available==='true';
            atc.disabled=!available;
            atc.textContent=available?(atc.dataset.availableText||'Add to cart'):(atc.dataset.soldText||'Sold out');
          }
          if(opt.dataset.mediaId) activateGalleryMedia(root,opt.dataset.mediaId);
        }
        select.addEventListener('change',update);
        update();
      });
    });

    bindFooterTabs(scope);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){ready(document);});
  }else{
    ready(document);
  }

  document.addEventListener('shopify:section:load',function(event){
    ready(event.target||document);
  });
})();
